import styled from 'styled-components';
import { GREY_600 } from '../../../../../constants';

export const NoTagsMessage = styled.p`
    color: ${GREY_600};
    font-size: 0.875rem;
    margin: 0;
    padding: 0.25rem 0;
    text-align: left;
`;
